// extracted by mini-css-extract-plugin
export default {"wrapper":"WarehousePage_wrapper__ME3RL"};